import React from "react";
import { useParams } from "react-router-dom";

import { useGetStepsByComponent } from "@hooks";
import { CommentView, ComponentDetails, Loading, Timeline } from "@components";
import { Layout } from "./PageLayouts";
import { NotFoundPage } from "./NotFoundPage";

export function ComponentPage() {
  const { componentSerial } = useParams();
  const { documents: componentSteps } = useGetStepsByComponent(
    componentSerial ? componentSerial : "",
  );
  return (
    <Layout>
      {componentSteps ? (
        componentSteps.length === 0 ? (
          <NotFoundPage />
        ) : (
          <>
            <ComponentDetails
              serial={componentSerial ? componentSerial : ""}
              steps={componentSteps}
              marginTop="32px"
            />
            <CommentView marginTop="8px" steps={componentSteps} />
            <Timeline steps={componentSteps} item="component" />
          </>
        )
      ) : (
        <Loading />
      )}
    </Layout>
  );
}
